import { Route, RouterModule } from '@angular/router';
import { CustomerNotFoundPage } from './customer-not-found/customer-not-found.page';
import { NotFoundPage } from './not-found/not-found.page';
import { ServerUnavailablePage } from './server-unavailable/server-unavailable.page';

const routes: Route[] = [
  {
    path: 'customer-not-found',
    component: CustomerNotFoundPage,
  },
  {
    path: 'server_unavailable',
    component: ServerUnavailablePage,
  },
  {
    path: '**',
    component: NotFoundPage,
  },
];

export const ErrorRouting = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/errors/error-routing.module.ts